module.exports = vant;


//////////////////
// WEBPACK FOOTER
// external "vant"
// module id = xcSH
// module chunks = 3